export default "__VITE_ASSET__U6AHL$Fv__"